module.exports = __webpack_public_path__ + "static/img/our-people-we-live-full-img1.f6c322f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-we-live-full-img1.jpg
// module id = bTz/
// module chunks = 0